import { initializeApp, getApps } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBvr3em67tFuTRLFQTF8xTSC70v3ev4hL0",
  authDomain: "clickcutgo-db.firebaseapp.com",
  projectId: "clickcutgo-db",
  storageBucket: "clickcutgo-db.firebasestorage.app",
  messagingSenderId: "631796840617",
  appId: "1:631796840617:web:e859563ab103dfec8b11b8",
  databaseURL: "https://clickcutgo-db-default-rtdb.asia-southeast1.firebasedatabase.app"
};

// Avoid duplicate app initialization
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

export const db = getDatabase(app);
export const storage = getStorage(app);
export default app;
